import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import { FontSize, TextStyle } from "@tiptap/extension-text-style";
import TextAlign from "@tiptap/extension-text-align";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import type { Extensions } from "@tiptap/core";
import TextExpansion from "./TextExpansion";

/**
 * Canonical formatting schema shared by every producer of reportable clinical
 * rich text. StarterKit v3 already supplies link and underline; keeping them in
 * one extension set avoids duplicate-extension parsing differences. Tab
 * handling also lives here so every clinical editor emits the same indentation.
 */
interface ClinicalRichTextExtensionOptions {
  supplementalTypography?: boolean;
}

export const ADDENDUM_FONT_SIZES = [
  "8pt",
  "9pt",
  "10pt",
  "11pt",
  "12pt",
  "14pt",
  "16pt",
  "18pt",
] as const;

export function createClinicalRichTextExtensions(
  placeholder: string,
  options: ClinicalRichTextExtensionOptions = {}
) {
  const extensions: Extensions = [
    StarterKit.configure({
      heading: false,
      codeBlock: false,
      code: false,
      blockquote: false,
      horizontalRule: false,
    }),
    Placeholder.configure({ placeholder }),
    TextStyle,
    Color,
    Highlight.configure({ multicolor: true }),
    TextExpansion,
  ];
  if (options.supplementalTypography) {
    extensions.push(FontSize, TextAlign.configure({ types: ["paragraph"] }));
  }
  return extensions;
}
